// extracted by mini-css-extract-plugin
export default {"card":"DisplayCampaign_card__ouPdB","readOnly":"DisplayCampaign_readOnly__BD4EK","formControlSideBySide":"DisplayCampaign_formControlSideBySide__DvkaJ"};